import { FormBuilder } from "@/components/form-builder"
import { HeaderForm } from "@/components/header-form"
import { SimpleAccordion } from "@/components/ui/simple-accordion"
import { FormActions } from "../components/person-steps/form-actions"
import { usePersonPersonalization } from "../hooks/use-person-personalization"
import { Personalization } from "@/components/individual-registration/personalization"
import { Form } from "@/components/ui/form"

interface PersonPersonalizationViewProps {
  onContinue: () => void
  onBack: () => void
}

export function PersonPersonalizationView({
  onContinue,
  onBack,
}: PersonPersonalizationViewProps) {
  const {
    form,
    isPending,
    onFormSubmit
  } = usePersonPersonalization({ onSuccess: onContinue })

  const accordionItems = [
    {
      id: "user",
      title: <HeaderForm title="PERFIL do USuário" />,
      content: <Personalization prefix="user" form={form} />
    },
    {
      id: "company",
      title: <HeaderForm title="PERFIL DA EMPRESA" />,
      content: <Personalization prefix="company" form={form} />
    }
  ]

  return (
    <div className="space-y-8">
      <Form {...form}>
        <form onSubmit={form.handleSubmit(onFormSubmit)} className="space-y-8">
          <SimpleAccordion
            className="bg-darkblue rounded-lg p-8"
            itemClassName="border-none"
            items={accordionItems}
          />
        </form>
      </Form>

      <FormActions
        isPending={isPending}
        onBack={onBack}
        onSubmit={() => form.handleSubmit(onFormSubmit)()}
        submitLabel="Finalizar"
        showDraft={false}
      />
    </div>
  )
}
